export default __webpack_public_path__ + "static/media/a014-longer.c39a3ecd.svg";